module.exports = __webpack_public_path__ + "img/close.f4f03a0f.svg";